module.exports = __webpack_public_path__ + "img/heart2heart-poser-image.8ccfa6de.jpg";